import styled from '@emotion/styled';
import { Button as CommonButton } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Button = styled(CommonButton)`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  width: 43px;
  height: 43px;
  padding: 8px;

  box-shadow: none;

  transition: opacity 0.15s ease-in-out;

  &.disable {
    cursor: initial;
    opacity: 0;
  }
`;
